import { render, staticRenderFns } from "./InviteActiveEdit.vue?vue&type=template&id=05a1bfbc"
import script from "./InviteActiveEdit.vue?vue&type=script&lang=js"
export * from "./InviteActiveEdit.vue?vue&type=script&lang=js"
import style0 from "./InviteActiveEdit.vue?vue&type=style&index=0&id=05a1bfbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports